import { Button } from '@aws-amplify/ui-react';
import React from 'react';
import './NothingHere.scss';

interface NothingHereProps {
  text?: string;
  children?: React.ReactNode;
  onCreateFirst?: () => void;
  createButtonText?: string;
  createButtonDisabled?: boolean;
}

export default function NothingHere({
  text = 'Nothing found',
  children,
  onCreateFirst,
  createButtonText = 'Create First',
  createButtonDisabled = false
}: NothingHereProps) {
  return (
    <div className="nothing-here">
      <div>{children || text}</div>
      {onCreateFirst && (
        <Button
          size="small"
          className="tiny"
          variation="primary"
          onClick={onCreateFirst}
          disabled={createButtonDisabled}
          style={{ marginTop: '16px' }}
        >
          {createButtonText}
        </Button>
      )}
    </div>
  );
}
